import React,{useMemo} from "react";
import { Card, Input } from "antd";

const PriceCard = ({sessions=[],packages=[],addons=[]}) => {
    const baseTotal = useMemo(() => {
    return sessions?.reduce((sum, s) => sum + parseFloat(s.base_fee || 0), 0)+packages?.reduce((sum, p) => sum + parseFloat(p.price || 0), 0)+addons?.reduce((sum, a) => sum + parseFloat(a.list_price || 0), 0);
  }, [sessions, packages, addons]);

  // You can replace this with your discount logic
  const discount = 0; 
  const amountPayable = baseTotal - discount;
  return (
    <Card
      bordered
      style={{
        width: 250,
        borderRadius: 8,
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        padding: 0,
        background: "linear-gradient(180deg, #000000, #666666)",
        color: "#fff",
        minHeight: '350px',
        display: "flex",                
        flexDirection: "column",
        minWidth: '270px',
        overflow: 'hidden',
        height: '400px'
      }}
      bodyStyle={{
        padding: 16,
        flex: 1,                       
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }}
    >
      <div>
      <div style={{ fontWeight: "bold", marginBottom: 4 }}>Base Total</div>
      <Input
          value={`$${baseTotal.toFixed(2)}`}
        style={{
          marginBottom: 16,
          backgroundColor: "#f9f9f9",
          borderRadius: 4
        }}
      />

      <div style={{ fontWeight: "bold", marginBottom: 4 }}>
        Auto Discount
      </div>
      <Input
        value={ "---"}
        disabled
        style={{
          marginBottom: 16,
          backgroundColor: "#f9f9f9",
          borderRadius: 4
        }}
      />

      <div style={{ fontWeight: "bold", marginBottom: 4 }}>Amount Payable</div>
      <Input
                value={`$${amountPayable.toFixed(2)}`}

        style={{
          marginBottom: 16,
          backgroundColor: "#f9f9f9",
          borderRadius: 4
        }}
      />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontWeight: "bold",
          fontSize: 16,
          paddingTop: 8,
          borderTop: "2px solid #fff",
           marginTop: "auto" 
        }}
      >
        <span>Total</span>
        <span>${amountPayable.toFixed(2)}</span>
      </div>
    </Card>
  );
};

export default PriceCard;
